// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3IMEt","dragIcon":"Choice_dragIcon__2liv3","left":"Choice_left__3eqMk","input":"Choice_input__2op4d"};